/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
import type { Link } from 'ember-link';

type TabBase = { label?: string };

type InternalTab = TabBase & {
  type: 'internal';
  internalLink: Link;
  externalLink?: never;
};

type ExternalTab = TabBase & {
  type: 'external';
  externalLink: string;
  internalLink?: never;
};

export type Tab = InternalTab | ExternalTab;

export interface TabsSignature {
  Args: {
    tabs: Tab[];
  };
}

const TabsComponent = templateOnlyComponent<TabsSignature>();
export default TabsComponent;
